import React from "react"
import PropTypes from "prop-types"
import { withApi } from "@tencent/react-aio"
import Dialog from "@/components/Dialog"
import _ from "lodash"
import { connect } from "react-redux"
import MessageBox from "@/components/MessageBox"
import * as ActionTypes from "@/stores/sale/actions"
import { Column, Table } from "@tencent/spaui"
import UserInfo from "@/business-components/sale/UserInfo"
import DateTime from "@/components/DateTime"

class BatchReleaseBlackList extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    title: PropTypes.string.isRequired,
    contactPhones: PropTypes.arrayOf(PropTypes.object),
  }

  constructor(props) {
    super(props)

    this.state = {
      disabled: false,
    }
  }

  render() {
    const { title, contactPhones } = this.props
    const { disabled } = this.state

    return (
      <Dialog className="ReleaseBlackListModal" {...this.props} style={{ width: 680 }} onSubmit={this.handleSubmit} onCancel={this.onCancel} disabled={disabled} submitLabel="不释放" cancelLabel="释放">
        <p>以下电话在黑名单中，是否释放此黑名单？</p>
        <Table data={contactPhones}>
          <Column name="phoneNumber">标记号码</Column>
          <Column name="grayList.markerId" render={this.renderUser}>
            黑名单标记人
          </Column>
          <Column name="grayList.dateTime" render={this.renderDateTime}>
            加入时间
          </Column>
          <Column name="grayList.memo">黑名单备注</Column>
        </Table>
      </Dialog>
    )
  }

  renderUser = (type, name, value) => {
    if (type === "head") {
      return value
    }
    return <UserInfo key={value} userId={value} />
  }

  renderDateTime = (type, name, value) => {
    if (type === "head") {
      return value
    }
    return <DateTime dateTime={value} />
  }

  onCancel = (e) => {
    e.preventDefault()
    const { webApi, contactPhones } = this.props
    const numbers = _.map(contactPhones, (phone) => phone.phoneNumber)
    this.setState({ disabled: true })

    webApi
      .batchReleaseBlackListRecord()
      .dispatchJson(ActionTypes.CONTACT_PHONE_LIST_STATUS, { data: { numbers: numbers } })
      .then(
        () => {
          this.setState({ disabled: false })
          this.props.onClose()
          this.props.onCancel()
        },
        (error) => {
          this.setState({ disabled: false })
          this.context.error("释放电话黑名单失败", error.message)
        }
      )
  }

  handleSubmit = () => {
    this.props.onClose()
    this.props.onSubmit()
  }
}

export default withApi(BatchReleaseBlackList)

BatchReleaseBlackList.contextType = MessageBox
